import React from 'react';
import classNames from 'classnames';
import { TextBlock } from '@thd-olt-component-react/loading-placeholder';
import proptypes from 'prop-types';
import { Card, CardBody } from '@one-thd/sui-atomic-components';

const { number } = proptypes;

export const ListTilePlaceholder = ({ numberOfThumbnails = 3 }) => {

  const wrapperClass = classNames(
    'sui-grid sui-gap-2',
    {
      'sui-grid-cols-1': numberOfThumbnails === 1,
      'sui-grid-cols-2': numberOfThumbnails === 2,
      'sui-grid-cols-3': numberOfThumbnails === 3,
      'sui-grid-cols-4': numberOfThumbnails === 4,
      'sui-grid-cols-5': numberOfThumbnails >= 5,
    }
  );

  return (
    <div className="sui-w-full" data-component="ListTilePlaceholder">
      <Card className="sui-grid sui-rounded-md sui-shadow-base">
        <TextBlock rows={2} color="#E1E1E1" widths={[50, 35]} />
        <CardBody>
          <div className={wrapperClass}>
            {
              Array.from({ length: numberOfThumbnails }, (__, num) => {
                return (
                  <div
                    // eslint-disable-next-line tailwindcss/no-arbitrary-value
                    className="sui-w-full"
                    key={`list-tile-placeholder-thumbnail-${num}`}
                  >
                    <div className="sui-aspect-square sui-w-full sui-bg-strong" />
                  </div>
                );
              })
            }
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

ListTilePlaceholder.displayName = 'ListTilePlaceholder';

ListTilePlaceholder.propTypes = {
  numberOfThumbnails: number
};

ListTilePlaceholder.defaultProps = {
  numberOfThumbnails: 3
};
